<div id="kt_quick_panel" class="offcanvas pt-5 pb-10 quick_panel_scroll"
    [ngClass]="extrasQuickPanelOffcanvasDirectionCSSClass" [class.offcanvas-on]="showpaneltoggle">
    <div class="offcanvas-header offcanvas-header-navs d-flex align-items-center justify-content-between mb-5">
        <div *ngIf="calcOutput" class="mt-n1 pe-7 search-wrapper" style="margin-left: 20px">
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)"
                    placeholder="{{ 'INFORMATE_POPUP.LABELS.SEARCH' | transloco }}" #input />
                <button mat-button matPrefix mat-icon-button class="search_btn">
                    <mat-icon>search</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div class="offcanvas-close mt-n1 pe-5">
            <a href="javascript:void(0)" class="btn btn-xs btn-icon btn-hover-primary kt_quick_panel_close"
                (click)="closetoggle()">
                <i class="ki ki-close icon-xs"></i>
            </a>
        </div>
    </div>
    <mat-accordion *ngIf="calcOutput" [multi]="true">
        <mat-expansion-panel *ngIf="boltFilterList?.length" (opened)="panelOpenState = true"
            (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <!-- Bolt -->
                    {{ 'ADVANCED_OUTPUT.LABELS.BOLT.Bolt' | transloco }}
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngFor="let item of boltFilterList">
                <div class="content-section">
                    <ng-container *transloco="let t; read: 'ADVANCED_OUTPUT.LABELS.BOLT'">
                        <p>{{ t(item.key) }}</p>
                        <span>{{ item.value }}</span>
                    </ng-container>
                </div>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="flangeFilterList?.length" (opened)="panelOpenState = true"
            (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <!-- Flange -->
                    {{ 'ADVANCED_OUTPUT.LABELS.FLANGE.Flange' | transloco }}
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngFor="let item of flangeFilterList">
                <div class="content-section">
                    <!-- <p>{{item.key}}</p><span>{{item.value}}</span> -->
                    <ng-container *transloco="let t; read: 'ADVANCED_OUTPUT.LABELS.FLANGE'">
                        <p>{{ t(item.key) }}</p>
                        <span>{{ item.value }}</span>
                    </ng-container>
                </div>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="gasketFilterList?.length" (opened)="panelOpenState = true"
            (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <!-- Gasket -->
                    {{ 'ADVANCED_OUTPUT.LABELS.GASKET.Gasket' | transloco }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let item of gasketFilterList">
                <div class="content-section">
                    <!-- <p>{{item.key}}</p><span>{{item.value}}</span> -->
                    <ng-container *transloco="let t; read: 'ADVANCED_OUTPUT.LABELS.GASKET'">
                        <p>{{ t(item.key) }}</p>
                        <span>{{ item.value }}</span>
                    </ng-container>
                </div>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="nutFilterList?.length" (opened)="panelOpenState = true"
            (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <!-- Nut -->
                    {{ 'ADVANCED_OUTPUT.LABELS.NUT.Nut' | transloco }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let item of nutFilterList">
                <div class="content-section">
                    <!-- <p>{{item.key}}</p><span>{{item.value}}</span> -->
                    <ng-container *transloco="let t; read: 'ADVANCED_OUTPUT.LABELS.NUT'">
                        <p>{{ t(item.key) }}</p>
                        <span>{{ item.value }}</span>
                    </ng-container>
                </div>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="weightFilterList?.length" (opened)="panelOpenState = true"
            (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <!-- Weight -->
                    {{ 'ADVANCED_OUTPUT.LABELS.WEIGHT.Weight' | transloco }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let item of weightFilterList">
                <div class="content-section">
                    <ng-container *transloco="let t; read: 'ADVANCED_OUTPUT.LABELS.WEIGHT'">
                        <p>{{ t(item.key) }}</p>
                        <span>{{ item.value }}</span>
                    </ng-container>
                </div>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="toolsDataFilterList?.length" (opened)="panelOpenState = true"
            (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <!-- Weight -->
                    Tool Data
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let item of toolsDataFilterList">
                <div class="content-section">
                    <ng-container>
                        <p>{{ item.key }}</p>
                        <span>{{ item.value }}</span>
                    </ng-container>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>